import z from "zod";

export const integrateWebfleetFormSchema = z.object({
	apiKey: z.string(),
	account: z.string().min(2).max(100),
	username: z.string().min(2).max(100),
	password: z.string().min(6).max(100),
});

export type IntegrateWebfleetFormSchema = z.infer<typeof integrateWebfleetFormSchema>;
